import { render, staticRenderFns } from "./MerchIP.vue?vue&type=template&id=7a8f88d4&scoped=true&"
import script from "./MerchIP.vue?vue&type=script&lang=js&"
export * from "./MerchIP.vue?vue&type=script&lang=js&"
import style0 from "./MerchIP.vue?vue&type=style&index=0&id=7a8f88d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8f88d4",
  null
  
)

export default component.exports